"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Wait = _interopRequireDefault(require("@react/react-spectrum/Wait/js/Wait"));

var _Loading = _interopRequireDefault(require("./Loading.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var Loading = function Loading(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_Loading.default.component),
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_Wait.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: _Loading.default.loadingMessage
  }, children));
};

Loading.defaultProps = {
  children: undefined,
  testId: 'loading'
};
Loading.propTypes = {
  children: _propTypes.default.node,
  testId: _propTypes.default.string
};
var _default = Loading;
exports.default = _default;